export default "__VITE_ASSET__892294cb__"